import { Icon } from "@utils/helper";
import { buildClass } from "@utils/tag";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/navigation";

const RegisterInfo = () => {
  const { push } = useRouter();
  const { t } = useTranslation("register");
  return (
    <div className="px-16 py-3 sm:pt-[48px] sm:basis-[50%] gap-3 sm:gap-0 sm:h-screen flex sm:block flex-col items-center">
      <Icon
        onClick={() => push("/")}
        className="cursor-pointer"
        width="119.23px"
        height="48px"
        viewBox="0 0 173 64"
        id="LogoWhite"
      />

      <p
        className={buildClass(
          "lg:w-[440px] text-[20px] md:text-[40px] sm:mt-[194px]",
          "lg:text-[64px] font-medium lg:leading-[78px]",
          "text-center lg:text-start text-white"
        )}
      >
        {t("signUp_title")}
      </p>
    </div>
  );
};

export default RegisterInfo;
